<section class="title-bar content-padding first-item">
    <div class="wrapper">
        <h2 class="left">Product Priority List</h2>
        <br class="clear">
        <div class="right">
            <a routerLink="nuovo" class="ml-10">
                <span class="btn btn-white" id="addSmsTemplate">Aggiungi<i class="ml-10 fas fa-plus"></i></span>
            </a>
        </div>
    </div>
    <br class="clear">
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="productPriorityLsitFilterForm" *ngIf="productPriorityLsitFilterForm" (ngSubmit)="filter()">
        </form>
    </div>
</section>